"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentBox = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const Theme_2 = require("../../Theme/Theme");
const NO_CHARS_REMAINING_DEFAULT_TEXT = 'Maximum character limit met';
const ErrorMessage = Theme_1.styled.div `
  font-family: ${(props) => props.theme.font.family.proximaNova};
  color: ${(props) => props.theme.red};
  background-color: transparent;
  margin-left: 12px;
`;
const StyledTextarea = Theme_1.styled.textarea `
  resize: none;
  font-family: inherit;
  padding: 12px;
  outline: 0;
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
  color: ${(props) => props.theme.gray};

  font-family: ${(props) => props.theme.font.family.proximaNova};
  background: ${(props) => props.background ? props.background : 'transparent'};
  border-radius: 4px;
  border: 1px solid
    ${(props) => (props.isLimitReached ? props.theme.red : props.theme.gray4)};

  &:focus {
    border: 1px solid
      ${(props) => (props.isLimitReached ? props.theme.red : props.theme.blue)};
  }

  &::placeholder {
    color: ${(props) => props.theme.gray3};
  }
`;
const Footer = Theme_1.styled.div `
  display: flex;
  font-size: 12px;
  justify-content: space-between;
  align-items: center;
  font-family: ${(props) => props.theme.font.family.proximaNova};
  color: ${(props) => props.theme.gray2};
`;
const StyledLabel = Theme_1.styled.label `
  font-family: ${(props) => props.theme.font.family.proximaNova};
  color: ${(props) => props.theme.gray2};
  margin-left: 12px;
`;
const CharLimitText = Theme_1.styled.div `
  margin-right: 12px;
  color: ${(props) => (props.error ? props.theme.red : props.theme.gray2)};
`;
const backgroundColor = (variant) => {
    switch (variant) {
        case 'white':
            return Theme_2.theme.white;
        case 'gray10':
            return Theme_2.theme.colors.gray[10];
        case 'gray20':
            return Theme_2.theme.colors.gray[20];
        default:
            return variant;
    }
};
exports.CommentBox = react_1.default.forwardRef(({ className = '', value, onChange, onBlur, onFocus, label, characterLimit = 0, characterLimitExceededText, rows, disabled = false, placeholder, background = 'transparent', }, ref) => {
    const id = 'input_multi';
    const hasCharLimit = characterLimit && characterLimit > 0;
    const remainingCharacters = Math.max(characterLimit - value.length, 0);
    const isLimitReached = remainingCharacters === 0;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(StyledTextarea, Object.assign({ id: id, value: value, onChange: onChange, onBlur: onBlur, onFocus: onFocus, placeholder: placeholder, ref: ref, disabled: disabled, rows: rows, isLimitReached: isLimitReached, background: backgroundColor(background) }, (hasCharLimit ? { maxLength: characterLimit } : {}))),
        react_1.default.createElement(Footer, null,
            isLimitReached && hasCharLimit ? (react_1.default.createElement(ErrorMessage, { id: `${id}-error` }, characterLimitExceededText || NO_CHARS_REMAINING_DEFAULT_TEXT)) : (react_1.default.createElement(StyledLabel, { htmlFor: id }, label)),
            hasCharLimit === true && (react_1.default.createElement(CharLimitText, { error: isLimitReached },
                value.length,
                " / ",
                characterLimit)))));
});
exports.CommentBox.displayName = 'CommentBox';
//# sourceMappingURL=CommentBox.js.map